import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { AllowService } from "@core/services/allow.service";
import { SearchConfig } from "@interfaces";
import { Booked, Company, Hotel, User } from "@models";
import { NgbDateParserFormatter, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import {
  AuthService,
  BookedService,
  GoogleMaps,
  CompanyService,
  NgxToastrService,
  SearchService,
  TravelUtilsService,
  UserService,
  UtilsService,
  FlightLleegoService,
} from "@services";
import { DialogAssignProjectComponent } from "@shared/component/dialog-assign-project/dialog-assign-project.component";
import { ViewPdfModalCompanyComponent } from "app/modules/businessEntities/company/booked-homepage/view-pdf-modal-company/view-pdf-modal-company.component";
import { AppState } from "app/modules/components/search/search.reducer";
import * as moment from "moment";
import { forkJoin, Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { SearchFormComponent } from "../search-form/search-form.component";
import { SummaryBookedComponent } from "./summary-booked/summary-booked.component";
import Swal from "sweetalert2";
import { LetItGoType } from "@core/models/letitgo-type";
import { AccommodationGuestsComponent } from "../accommodation-guests/accommodation-guests.component";
import { UserCardModalComponent } from "@shared/component/user-card-modal/user-card-modal.component";
import { ExpiredModalComponent } from "@shared/component/expired-modal/expired-modal.component";

@Component({
  selector: "app-search-see-booked",
  templateUrl: "./search-see-booked.component.html",
  styleUrls: ["./search-see-booked.component.scss"],
})
export class SearchSeeBookedComponent implements OnInit, OnDestroy {
  public lat: number = 51.678418;
  public lng: number = 7.809007;
  actualRoom: number = null;
  hotel: Hotel;
  code: number;
  uuid: string;
  canRequest: boolean;
  comments = "";
  travelData: any = {};
  searchConfig: SearchConfig;
  totalArray: any[] = [];
  countStars: any[] = [];
  subscription = new Subscription();
  isUser: boolean;
  uuidUser: string;
  isAdmin = false;
  isEmployee: boolean = false;
  private subcriptions: Subscription[] = [];
  canUseTRM: boolean;
  userToBook: string;
  showPolicies: boolean;
  actualGroupRoom: number;
  userFilter: any;
  totalAdults = 0;
  hotelsMapCopy: Hotel[];
  hotelsListCopy: Hotel[];
  selectedOccupancy: {
    adults: number;
    rooms: number;
    paxes: any[];
  };
  selectedRoom: any;
  selectedRooms: any[] = [];
  selectedRoomIndex: number;
  selectedRoomsCopy: any[] = [];
  totalPrice = 0;
  canOnlyRequestRooms = false;
  mapHasBeenDragged: boolean = false;
  firstSearch: boolean = false;
  @ViewChild("bottom") bottom!: ElementRef;
  orderSummary: any[] = [];
  areAllFormsValid: boolean;
  isInvalid: boolean = false;
  @ViewChild("scrollAfterChangeRoom") scrollAfterChangeRoom: ElementRef;
  guests: any[] = [];
  user: User;
  filters: any;
  starAuthRequired: boolean = false;
  filtersApplicated: any;
  facilities: any;
  bookingInfo: any;
  selectedUsers: any;
  selectedTravelers: any;
  projectData: any;
  selectedPolicy: any;
  isDescriptionExpanded = false;
  isDetailsExpanded = false;
  roomFilters = [
    { code: 'breakfast', name: 'Breakfast Included' },
    { code: 'cancellation', name: 'Free Cancellation' }
  ];
  selectedFilters: Set<string> = new Set<string>();
  filteredRooms: any[] = [];
  selectedBedTypes: { [key: string]: string } = {};
  filteredRates: { [key: string]: any[] } = {};
  bedTypesForRooms: { [roomId: string]: string[] } = {};
  roomRatesVisibility: { [key: string]: boolean } = {};
  externalUser: any;
  company: Company;
  originalSearchConfig: any;
  formattedPlace: any;
  flightInfo;
  isPackageRate: string;
  private packageFlow = {
    enabled: false,
    hotelDone: false,
    flightDone: false,
    navigated: false,
    flightFailed: false,
    flightErr: null as any,
  };
  private pendingHotel = new Set<string>();
  private expiredModalOpen = false;
  private expiredHandledCorrelationIds = new Set<string>();

  constructor(
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private searchService: SearchService,
    private ngxToastrService: NgxToastrService,
    private store: Store<AppState>,
    private bookedService: BookedService,
    public translate: TranslateService,
    private ngbDateParser: NgbDateParserFormatter,
    private router: Router,
    private travelUtilsService: TravelUtilsService,
    private userService: UserService,
    public utilsService: UtilsService,
    public allowService: AllowService,
    private authService: AuthService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private googleMaps: GoogleMaps,
    private companyService: CompanyService,
    private flightLleegoService: FlightLleegoService,
  ) {
    this.subcriptions.push(
      this.store.select("auth").subscribe((s: any) => {
        this.externalUser = s?.user;
        if (s.user && s.user.type?.toUpperCase() !== "USER" && (s.user.type?.toUpperCase() === "COMPANY" || s.user.type?.toUpperCase() === "EMPLOYEE" ||
            s.user.type?.toUpperCase() === "AGENCY" || s.user.type?.toUpperCase() === "HUB")) {
          this.isAdmin = true;
          if (s.user.type?.toUpperCase() === "EMPLOYEE") {
            this.isEmployee = true;
          }
          this.userToBook = localStorage.getItem("userToBook")
            ? this.utilsService.decrypt(localStorage.getItem("userToBook"))
            : null;
          this.userService.getUser(this.userToBook || s.user.uuid).subscribe(u => {
            this.user = u;

            if (this.user?.companyUuid) {
              this.companyService.getCompany(this.user.companyUuid).subscribe(
                (company: Company) => {
                  this.company = company;
                },
                (error) => {}
              );
            }

          })
        } else {
          this.userService.getUser(s.user.uuid).subscribe(
            (res) => {
              this.user = res;
              if (this.user?.companyUuid) {
                this.companyService.getCompany(this.user.companyUuid).subscribe(
                  (company: Company) => {
                    this.company = company;
                  },
                  (error) => {}
                );
              }
            },
            (err) => {}
          );
        }
        this.canUseTRM = s.user.type
          ? s.user.plan && s.user.plan.permissions.canUseTRM
          : s.user.user.plan && s.user.user.plan.permissions.canUseTRM;
        if(!this.canUseTRM){
          this.canUseTRM = this.authService.userCompanyPlan?.permissions.canUseTRM;
        }
      })
    );
    const navigation = this.router.getCurrentNavigation();

    this.searchConfig = this.searchService.searchConfig;
    this.originalSearchConfig = JSON.parse(JSON.stringify(this.searchConfig));
    if (navigation && navigation.extras && navigation.extras.state) {
      this.searchConfig = navigation.extras?.state?.searchConfig;
      this.originalSearchConfig = JSON.parse(JSON.stringify(this.searchConfig));
      this.hotelsMapCopy = navigation.extras?.state?.hotelsMapCopy;
      this.hotelsListCopy = navigation.extras?.state?.hotelsListCopy
      this.filters = navigation.extras?.state?.filters
      this.starAuthRequired = navigation.extras?.state?.starAuthRequired;
      this.filtersApplicated = navigation.extras?.state?.filtersApplicated
      this.facilities = navigation.extras?.state?.facilities
      this.selectedUsers = navigation.extras?.state?.selectedUsers
      this.selectedTravelers = navigation.extras?.state?.selectedTravelers
      this.projectData = navigation.extras?.state?.projectData;
      this.userFilter = navigation.extras?.state?.userFilter;
      this.selectedPolicy = navigation.extras?.state?.selectedPolicy;
      this.company = navigation.extras.state.company;
    }
    
    const savedStateString = localStorage.getItem('stateRedirect');
    if (savedStateString) {
      const savedState = JSON.parse(savedStateString);
      this.searchConfig = savedState.searchConfig;
      this.originalSearchConfig = JSON.parse(JSON.stringify(this.searchConfig));
      this.hotelsMapCopy = savedState.hotelsMapCopy;
      this.hotelsListCopy = this.hotelsMapCopy;
      this.filters = savedState.filters;
      this.starAuthRequired = savedState.starAuthRequired;
      this.filtersApplicated = savedState?.filtersApplicated
      this.facilities = savedState.facilities;
      this.selectedUsers = savedState.selectedUsers;
      this.projectData = savedState.projectData;
      this.selectedPolicy = savedState?.selectedPolicy;
      if(this.selectedPolicy){
        this.userFilter = this.selectedPolicy.filters;
      }
      const companyUuid = savedState.company;
      if (companyUuid) {
        this.companyService.getCompany(companyUuid).subscribe(
          (company: Company) => {
            this.company = company;
          },
          (error) => {}
        );
      }

      this.selectedTravelers = [];
      let userIndex = 0;
      if (this.searchConfig?.occupancies?.length && this.selectedUsers?.length) {
        this.searchConfig.occupancies.forEach((occupancy, index) => {
          const travelersInRoom = [];
          for (let i = 0; i < occupancy.adults; i++) {
            if (this.selectedUsers[userIndex]) {
              travelersInRoom.push(this.selectedUsers[userIndex].uuid);
              userIndex++;
            }
          }
          this.selectedTravelers[index] = travelersInRoom;
        });
      }

      localStorage.removeItem('stateRedirect');
    }

    this.store
      .select("auth")
      .pipe(take(1))
      .subscribe((auth) => {
        if (auth.isAuthenticated) {
          this.uuidUser = this.searchConfig.userUuid
            ? this.searchConfig.userUuid
            : auth.user.uuid;
        }
        const st: any = auth;
        this.isUser = st.user.type?.toUpperCase() === "USER" ? true : false;
      });
      this.utilsService.socket.on("create-booking", (result) => {
        this.bookingInfo = this.utilsService.getBookingInfo();
        this.selectedRooms = this.utilsService.getSelectedRooms();
        this.projectData = this.utilsService.getProjectData();
        if(!this.selectedUsers){
          this.selectedUsers = this.utilsService.getSelectedUsers();
        }
        if(!this.hotel){
          this.hotel = this.utilsService.getHotelInfo();
        }

        if (this.utilsService.correlationId.includes(result.correlationId)) {
          this.utilsService.correlationId.splice(this.utilsService.correlationId.indexOf(result.correlationId), 1)
          if (this.pendingHotel.has(result.correlationId)) {
            this.pendingHotel.delete(result.correlationId);
          }
          if (this.packageFlow.enabled) {
            this.packageFlow.hotelDone = (this.pendingHotel.size === 0);
            this.updatePackageLoading();
            this.tryFinishPackageFlow();
          }
          if (!this.packageFlow.enabled) {
            this.utilsService.loadingHotels = false;
          } else {
            this.updatePackageLoading();
          }
          const user = this.selectedUsers.find(u => u.correlationId === result.correlationId);
          const userUuid = user ? user.uuid : this.uuidUser;
          const cid = result?.correlationId;
          if (cid && this.expiredHandledCorrelationIds.has(cid)) {
            return;
          }

          const isExpired =
            result?.data?.statusCode === 817 || result?.data?.errorCode === 'TOKEN_EXPIRED';

          if (isExpired) {
            if (cid) this.expiredHandledCorrelationIds.add(cid);

            const idx = this.utilsService.correlationId.indexOf(cid);
            if (idx >= 0) this.utilsService.correlationId.splice(idx, 1);

            if (this.expiredModalOpen) return;
            this.expiredModalOpen = true;

            this.utilsService.loadingHotels = false;

            const modalRef = this.modalService.open(ExpiredModalComponent, {
              windowClass: 'custom-modal-expired',
              centered: true,
              backdrop: 'static',
              keyboard: false,
            });

            modalRef.componentInstance.redirectTo = `/search/${userUuid}`;

            modalRef.result.finally(() => {
              this.expiredModalOpen = false;
              this.expiredHandledCorrelationIds.clear();
            });

            return;
          }
          if((result.data.type && (result.data.type?.toLowerCase().includes("error") || result.data.type?.toLowerCase().includes("exception"))) || (result.data.bookingStatus && (result.data.bookingStatus?.toLowerCase().includes('unknown') || result.data.bookingStatus?.toLowerCase().includes('error')))) {
            if (result.data.status === 410 && result.data.message === "Sold Out") {
              this.translate
                .get([
                  "search.search-booked.sold-out",
                ])
                .subscribe((response) => {
                  Swal.fire({
                    position: "center",
                    imageUrl:
                      "../../../../../assets/img/svg/check-circle.svg",
                    title: '',
                    text: response[
                      "search.search-booked.sold-out"
                    ],
                    showConfirmButton: false,
                    timer: 10000,
                  })
                })
            } else {
              this.translate
              .get([
                "common.congrat",
                "search.search-booked.success-room-booked",
              ])
              .subscribe((response) => {
                Swal.fire({
                  position: "center",
                  imageUrl:
                    "../../../../../assets/img/svg/check-circle.svg",
                  title: response["common.congrat"],
                  text: response[
                    "search.search-booked.success-room-booked"
                  ],
                  showConfirmButton: false,
                  timer: 300000000000,
                }).then(() => {
                  const checkInAux = moment(
                    moment(
                      this.ngbDateParser.format(this.searchConfig.checkIn),
                      "DD/MM/YYYY"
                    ).toLocaleString()
                  ).format("YYYY-MM-DD");
                  const checkOutAux = moment(
                    moment(
                      this.ngbDateParser.format(this.searchConfig.checkOut),
                      "DD/MM/YYYY"
                    ).toLocaleString()
                  ).format("YYYY-MM-DD");
                  const room = this.bookingInfo.rooms.find((r) => r.correlationId === result.correlationId)
                  const params = {
                    rooms: [room],
                    destinationName: this.hotel.address,
                    checkIn: checkInAux,
                    checkOut: checkOutAux,
                    userUuid: userUuid,
                    comments: "",
                    hotelName: this.hotel.name,
                    guests: this.guests,
                  };
                  if (this.bookingInfo.customCode !== "") {
                    params["customCode"] = this.bookingInfo.customCode;
                  }
                  if (this.bookingInfo.costCenter !== "") {
                    params["costCenter"] = this.bookingInfo.costCenter;
                  }
                  params['hotel'] = this.hotel;
                  const bookUuid = result?.data?.uuid 
                                    ?? result?.data?.booked?.uuid 
                                    ?? result?.book?.uuid;
                  const roomIndex = this.selectedRooms.findIndex(r => r.correlationId === room.correlationId);
                  if(this.projectData && this.projectData.selectedProject && this.projectData.selectedProject.uuid !== "none"){
                    this.addToTravel(bookUuid);
                  }
                  this.createBookingFailed(result, room, roomIndex, params, this.bookingInfo);
                });
              });
            }
          } else {
            this.translate
            .get([
              "common.congrat",
              "search.search-booked.success-room-booked",
            ])
            .subscribe((response) => {
              Swal.fire({
                position: "center",
                imageUrl:
                  "../../../../../assets/img/svg/check-circle.svg",
                title: response["common.congrat"],
                text: response[
                  "search.search-booked.success-room-booked"
                ],
                showConfirmButton: false,
                timer: 3000,
              }).then(() => {
                    //this.onGetPDF(result.data);
                    const bookUuid = result?.data?.uuid 
                                  ?? result?.data?.booked?.uuid 
                                  ?? result?.book?.uuid;
                    if(this.projectData && this.projectData.selectedProject && this.projectData.selectedProject.uuid !== "none"){
                      this.addToTravel(bookUuid);
                    }

                    if (this.packageFlow.enabled) {
                      this.packageFlow.hotelDone = (this.pendingHotel.size === 0);
                      this.updatePackageLoading();
                      this.tryFinishPackageFlow();
                      return;
                    }

                    this.cleanSearchData();
                    const route = this.utilsService.getNavigationRoute(this.externalUser, null, this.canUseTRM);
                    if (route) {
                      this.router.navigate([route], { queryParams: { specialAction: true } });
                    }
              });
            });
          }
        }
      })
  }

  ngOnInit() {
    this.isPackageRate = localStorage.getItem("isPackageRate")
    const flight = localStorage.getItem("packageRateFlightInfo");
    if (flight) {
      this.flightInfo = JSON.parse(flight)
    }
    this.travelUtilsService.removeTravelLocalStorage();
    this.code = this.activatedRoute.snapshot.params.code;
    this.uuid = this.activatedRoute.snapshot.queryParams.hotelUuid;
    this.canRequest =
      this.activatedRoute.snapshot.queryParams.canRequest === "true"
        ? true
        : false;
    this.travelData = this.travelUtilsService.getTravelLocalStorage();
    if (!this.searchConfig.checkIn || !this.searchConfig.checkOut) {
      this.router.navigate(["/search"]);
      return false;
    }
    this.totalAdults = 0;
    this.searchConfig.occupancies.forEach((o) => {
      this.totalAdults += o.adults;
    });
    this.selectedOccupancy = this.searchConfig.occupancies[0];

    this.userService
      .getPoliciesUser(this.uuidUser)
      .pipe(take(1))
      .subscribe((policy) => {
        if (this.userFilter) {
          this.canOnlyRequestRooms = this.userFilter.onlyAuthorization;
        } else {
          this.userFilter = policy.filters;
          this.canOnlyRequestRooms = this.userFilter.onlyAuthorization;
        }

        this.hotel = this.hotelsListCopy.find((h) => h.code === this.code);
        this.route.queryParams.subscribe((params) => {
          // Extrae el valor de hotelUuid de los parámetros
          const hotelUuid = params["hotelUuid"];
          if (this.hotel)
            this.hotel.uuid = hotelUuid;
        });


        try {
          this.countStars = new Array(Math.floor(Number(this.hotel.stars)));
        } catch (e) {
          this.countStars = new Array();
        }
        this.utilsService.loadingHotels = false;
        if (this.hotel && this.hotel.rooms) {
          this.initializeFilteredRates();
          this.filteredRooms = this.filterByOccupancy(this.hotel.rooms);
          this.updateFilteredRates();
        }

        if (this.hotel?.coordinates?.latitude && this.hotel?.coordinates?.longitude) {
          this.googleMaps.geocodeLatLng(
            parseFloat(this.hotel.coordinates.latitude),
            parseFloat(this.hotel.coordinates.longitude)
          ).subscribe((geoData) => {
            if (geoData) {
              const { city, country } = geoData;
              this.formattedPlace = `${city}, ${country}`.toLowerCase();
            }
          });
        }
      });
      this.filteredRooms.forEach(room => {
        this.roomRatesVisibility[room.code] = false;
      });
      const params = { ...this.activatedRoute.snapshot.queryParams };
      const Ds_SignatureVersion = params['Ds_SignatureVersion'];
      const Ds_MerchantParameters = params['Ds_MerchantParameters'];
      const Ds_Signature = params['Ds_Signature'];
      
      if (Ds_SignatureVersion && Ds_MerchantParameters && Ds_Signature) {
        const redsysData = {
          Ds_SignatureVersion,
          Ds_MerchantParameters,
          Ds_Signature,
        };

        const cardName = localStorage.getItem('cardName');
        if (cardName) {
          redsysData['cardName'] = cardName;
          localStorage.removeItem('cardName');
        }
          const uuidToBook = this.userToBook ? this.userToBook : this.uuidUser;
          this.userService
          .postUserNewTokenRedsys(uuidToBook, redsysData)
          .subscribe(
            (result) => {
              this.user = result;
              this.translate.get("company.card.card-added").subscribe((resp) => {
                this.ngxToastrService.typeSuccess(null, resp);
              });
            },
            (err) => {
              this.translate.get("company.card.error").subscribe((resp) => {
                this.ngxToastrService.typeInfo(null, resp);
              });
            }
          );
      }
  }

  ngOnDestroy(): void {
    this.utilsService.socket.off('create-booking');
    localStorage.removeItem('stateRedirect');
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  handleTravelFlow(bookingUuid: string) {
    const checkInAux = moment(
      this.ngbDateParser.format(this.searchConfig.checkIn),
      "DD/MM/YYYY"
    ).format("YYYY-MM-DD");
    const checkOutAux = moment(
      this.ngbDateParser.format(this.searchConfig.checkOut),
      "DD/MM/YYYY"
    ).format("YYYY-MM-DD");
    const bookingData = {
      initDate: checkInAux,
      endDate: checkOutAux,
      bookingUuid: bookingUuid,
      type: "booking",
    };

    bookingData["userUuid"] = this.uuidUser;
    const dialogAssignProject = this.dialog.open(DialogAssignProjectComponent, {
      data: { bookingData, isUser: this.isUser, isNewBooking: true },
      panelClass: "new-dialog",
    });
    return dialogAssignProject.afterClosed();
  }

  onGetPDF(booked: any) {
    const downloadRequests = [];
  
    if (booked.bonoFileUrl && Array.isArray(booked.bonoFileUrl)) {
      for (let fileUrl of booked.bonoFileUrl) {
        downloadRequests.push(this.bookedService.getBookedsPdf(fileUrl).pipe(take(1)));
      }
    }else if (booked.voucherFile && Array.isArray(booked.voucherFile)) {
      for (let file of booked.voucherFile) {
        const url = `/media/${file.uuid}/custom`;
        downloadRequests.push(this.bookedService.getCustomBookingPdf(url).pipe(take(1)));
      }
    }
    if (downloadRequests.length > 0) {
      this.subcriptions.push(
        forkJoin(downloadRequests).subscribe(
          (responses) => {
            responses.forEach((res, index) => {
              const modalRef = this.modalService.open(
                ViewPdfModalCompanyComponent,
                { size: "lg", centered: true }
              );
              modalRef.componentInstance.blobUrl = URL.createObjectURL(res);
              modalRef.componentInstance.fileName = booked.apiReference + `_${index + 1}`;
            });
          },
          () =>
            this.translate
              .get(["common.error-pdf"])
              .pipe(take(1))
              .subscribe((value) =>
                this.ngxToastrService.typeInfo(null, value["common.error-pdf"])
              )
        )
      );
    }
  }

  isSameOrAfterToday(date) {
    return date ? moment(date).isSameOrAfter(moment()) : null;
  }

  hoverCancel(i: number, j: number) {
    this.actualRoom = i;
    this.actualGroupRoom = j;
    this.showPolicies = !this.showPolicies;
  }

  openSearchModal() {
    const modalRef = this.dialog.open(SearchFormComponent, {
      panelClass: "hotel-form-modal",
    });
    modalRef.componentInstance.openModal = true;
    modalRef.componentInstance.isOnDetails = true;
    modalRef.componentInstance.userToBook = this.userToBook;
    modalRef.componentInstance.searchConfig = this.searchConfig;
    modalRef.componentInstance.hotelsMapCopy = this.hotelsMapCopy;
    modalRef.componentInstance.hotelsListCopy = this.hotelsListCopy;
    modalRef.componentInstance.emitData.subscribe((data) => {
      this.searchConfig = data;
      const url = this.userToBook ? `/search/${this.userToBook}` : "/search";
      this.router.navigate([url], {
        state: {
          searchConfig: this.searchConfig,
          hotelsMapCopy: this.hotelsMapCopy,
          hotelsListCopy: this.hotelsListCopy,
          newSearch: true,
        },
      });

      modalRef.close();
    });
  }

  goBack() {
    this.router.navigate(
      [
        `/search${
          (this.isAdmin && this.canUseTRM) || this.isEmployee
            ? "/" + this.userToBook
            : ""
        }`,
      ],
      {
        state: {
          searchConfig: this.searchConfig,
          originalSearchConfig: this.originalSearchConfig,
          hotelsMapCopy: this.hotelsMapCopy,
          hotelsListCopy: this.hotelsListCopy,
          filters: this.filters,
          facilities: this.facilities,
          selectedUsers: this.selectedUsers,
          selectedTravelers: this.selectedTravelers,
          projectData: this.projectData,
          starAuthRequired: this.starAuthRequired,
          selectedPolicy: this.selectedPolicy,
          filtersApplicated: this.filtersApplicated
        }
      }
    );
  }

  selectRoom(room, rate) {
    if (this.selectedRoom && room !== this.selectedRoom && rate !== this.selectedRoom.rates[0]) {
      this.selectedRooms[this.getCurrentOccupancyIndex()] = null;
    }
    if (room !== this.selectedRoom || rate !== this.selectedRoom.rates[0]) {
      this.selectedRoom = {...room};
      this.selectedRoom.paxes = new Array(this.searchConfig.occupancies[this.getCurrentOccupancyIndex()].adults).fill(
        {
          roomId: this.getCurrentOccupancyIndex() + 1,
          type: "AD"
        }
      )
      this.selectedRoom.rates = [{...rate}];
      this.resetPriceAndUpdate();
      this.totalPrice += Number.parseFloat(
        rate.totalWithPercentage
      );
      this.selectedRooms[this.getCurrentOccupancyIndex()] = this.selectedRoom;
    }
  }

  resetPriceAndUpdate() {
    this.totalPrice = 0;
    if (this.selectedRooms[0] != null) {
      this.selectedRooms.forEach((selectedRoom) => {
        if (selectedRoom != null) {
          this.totalPrice += Number.parseFloat(
            selectedRoom.rates[0].totalWithPercentage
          );
        }
      });
    }
    if (this.selectedRooms[this.getCurrentOccupancyIndex()] != null) {
      this.totalPrice -= Number.parseFloat(
        this.selectedRooms[this.getCurrentOccupancyIndex()].rates[0]
          .totalWithPercentage
      );
    }
  }

  changeNextRoom(isNext: boolean) {
    this.scrollToComponent();
    const idx = this.getCurrentOccupancyIndex();
    let newIdx = 0;
    if (isNext) {
      newIdx = idx + 1;
      this.selectedOccupancy = this.searchConfig.occupancies[newIdx];

      // Find if room is already in orderSummary list and update it
      const isInSummary = this.orderSummary.findIndex(
        (room) => room.id === newIdx
      );
      if (isInSummary !== -1) {
        this.orderSummary.push({ room: this.selectedRooms[idx], id: idx });
        this.orderSummary.splice(isInSummary, 1);
      } else {
        this.orderSummary.push({ room: this.selectedRooms[idx], id: idx });
      }
    } else {
      newIdx = idx - 1;
      this.selectedOccupancy = this.searchConfig.occupancies[newIdx];

      // Add last selectedRoom to orderSummary list
      this.orderSummary.push({ room: this.selectedRooms[idx], id: idx });
      // Find if room is already in orderSummary list and update it
      const isInSummary = this.orderSummary.findIndex(
        (room) => room.id === newIdx
      );
      if (isInSummary !== -1) {
        this.orderSummary.splice(isInSummary, 1);
      } else {
        this.orderSummary.push({ room: this.selectedRooms[idx], id: idx });
      }
    }
    if (this.selectedRooms[newIdx] != null) {
      this.selectedRoom = this.selectedRooms[newIdx];
    } else {
      this.selectedRoom = null;
    }
    this.filteredRooms = this.filterByOccupancy(this.hotel.rooms);
    this.updateFilteredRates();
  }

  getCurrentOccupancyIndex() {
    return this.searchConfig.occupancies.findIndex(
      (occupancy) => occupancy === this.selectedOccupancy
    );
  }

  isFirstMiddleOrLast() {
    const index = this.searchConfig.occupancies.findIndex(
      (occupancy) => occupancy === this.selectedOccupancy
    );
    if (index === this.searchConfig.occupancies.length - 1) {
      return 1;
    } else if (index > 0 && index < this.searchConfig.occupancies.length - 1) {
      return 0;
    } else {
      return -1;
    }
  }

  isChecked(room, rate) {
    return this.selectedRoom != null
      && this.selectedRoom.code == room.code
      && this.selectedRoom.rates[0].rateKey == rate.rateKey
      && this.selectedRoom.rates[0].boardCode == rate.boardCode
      && this.selectedRoom.rates[0].bed == rate.bed
      && this.selectedRoom.rates[0].cancellationPolicies[0]?.text == rate.cancellationPolicies[0]?.text;
  }

  checkIfAllotment(rate: any): boolean {
    if (rate.allotment == null || rate.allotment < 1) {
      return false;
    }
 
    const currentIndex = this.getCurrentOccupancyIndex();
 
    const usedInOtherRooms = (this.selectedRooms || []).filter((room, idx) =>
      room &&
      idx !== currentIndex &&
      room.rates &&
      room.rates[0] &&
      room.rates[0].rateKey === rate.rateKey &&
      room.rates[0].adults === rate.adults
    ).length;
 
    return usedInOtherRooms < rate.allotment;
  }

  filterByOccupancy(rooms: any[]) {
    let res = [];
    rooms.forEach((room: any) => {
      const ratesFiltered = room.rates.filter((rate: any) => {
        const matchesOccupancy = rate.adults == this.selectedOccupancy.adults && this.checkIfAllotment(rate);
        const matchesBreakfast = !this.selectedFilters.has('breakfast') || ['HB', 'AI', 'BB'].includes(rate.boardCode);
        const matchesCancellation = !this.selectedFilters.has('cancellation') || this.hasFreeCancellation(rate);
        
        return matchesOccupancy && matchesBreakfast && matchesCancellation;
      });

      if (ratesFiltered.length > 0) {
        res.push({ ...room, rates: ratesFiltered });
      }
    });
    return res;
  }

  getOffersPercentage(roomRate) {
    const offer = roomRate.offers[0].amount;
    const price = roomRate.totalWithPercentage;
    let percentage = Math.round((offer * 100) / price);
    return percentage.toString();
  }

  doBooking() {
    if (!this.guests || this.guests.length !== this.totalAdults) {
      return this.translate
        .get(["hotel.should-guests-data"])
        .subscribe((result) => {
          this.ngxToastrService.typeInfo(
            "",
            result["hotel.should-guests-data"]
          );
        });
    }
    this.isInvalid = false;
    this.selectedRooms[this.getCurrentOccupancyIndex()] = this.selectedRoom;
    this.selectedRoomsCopy = this.selectedRooms;
  
    const requiresCardSelection = this.selectedRooms.some((room) => {
      return this.getUserBookingOption(room.rates[0]) === 1;
    });
    const isSummaryRequest = this.selectedRooms.some((room) => {
      return this.getUserBookingOption(room.rates[0]) === 2;
    });
    const shouldShowCardSelector =
      (requiresCardSelection && this.canRequest && !this.starAuthRequired && !this.canOnlyRequestRooms && !this.company.bookedWithoutCard) || this.isEmployee || this.isAdmin;
  
    const cardSelectionPromise = shouldShowCardSelector
      ? this.showPaymentCardSelector()
      : Promise.resolve(null);
  
    cardSelectionPromise.then((selectedCard) => {
      if (!selectedCard && !this.company.bookedWithoutCard && shouldShowCardSelector) {
        return;
      }
      const modalRef = this.modalService.open(SummaryBookedComponent, {
        size: "lg",
        centered: true,
      });
      this.translate
        .get(["hotel.check-booking-details", "hotel.change-during-process"])
        .subscribe((result) => {
          this.ngxToastrService.typeInfo(
            result["hotel.check-booking-details"],
            result["hotel.change-during-process"]
          );
        });
      modalRef.componentInstance.hotel = this.hotel;
      modalRef.componentInstance.totalAdults = this.totalAdults;
      modalRef.componentInstance.searchConfig = this.searchConfig;
      modalRef.componentInstance.selectedRooms = [...this.selectedRooms];
      modalRef.componentInstance.code = this.code;
      modalRef.componentInstance.isEmployee = this.isEmployee;
      modalRef.componentInstance.isAdmin = this.isAdmin;
      modalRef.componentInstance.guests = [...this.guests];
      modalRef.componentInstance.uuidUser = this.uuidUser;
      modalRef.componentInstance.company = this.company;
      modalRef.componentInstance.selectedUsers = this.selectedUsers;
      modalRef.componentInstance.isSummaryRequest = isSummaryRequest;
      modalRef.componentInstance.starAuthRequired = this.starAuthRequired;
      modalRef.componentInstance.canOnlyRequestRooms = this.canOnlyRequestRooms;
      modalRef.componentInstance.sendInfo.subscribe((bookingInfo) => {
        if (this.isPackageRate && this.isPackageRate === 'accommodation' && this.isPackage()) {

          localStorage.setItem('packageRateAccomInfo', JSON.stringify({searchConfig: this.searchConfig, bookingInfo, hotel: this.hotel, selectedTravelers: this.selectedTravelers, uuidUser: this.uuidUser, guests: this.guests, company: this.company, selectedCard, isEmployee: this.isEmployee, isAdmin: this.isAdmin, canRequest: this.canRequest, userFilter: this.userFilter, canOnlyRequestRooms: this.canOnlyRequestRooms, selectedUsers: this.selectedUsers, projectData: this.projectData, selectedRooms: this.selectedRooms, canUseTRM: this.canUseTRM, totalAdults: this.totalAdults, selectedOccupancy: this.selectedOccupancy, externalUser: this.externalUser, isUser: this.isUser, needsAuth: this.getAuthorization(this.selectedRooms)}))

          const dataFromCompany = {
            type: 'flight',
            userUuid: this.uuidUser,
            companyUuid: this.company.uuid,
            isModal: false,
            isManual: false,
          };
          modalRef.close()
          this.router.navigateByUrl(`flight`, { state: { dataFromCompany } });
        } 
      else {
        modalRef.componentInstance.loading = true;
        this.utilsService.loadingHotels = true;

        const isFlightPackage =
          this.isPackageRate === 'flight' && this.isPackage();

        if (isFlightPackage) {
          this.startPackageFlowIfNeeded();
          const continueWithHotel = (doneOk = true, err?: any) => {
            this.resolvePackageFlight(doneOk, err);
            localStorage.removeItem('packageRateFlightInfo');
            localStorage.removeItem('isPackageRate');
            this.continueHotelBookingFlow(bookingInfo, modalRef, selectedCard);
          };

          const backToFlightResults = () => {
            this.packageFlow.enabled = false;
            this.packageFlow.flightDone = false;
            this.packageFlow.hotelDone = false;
            this.packageFlow.navigated = false;
            this.packageFlow.flightFailed = false;
            this.packageFlow.flightErr = null;

            this.utilsService.loadingHotels = false;
            modalRef.close();
            this.router.navigate(['/flight'], { queryParams: { didSearch: true } });
          };

          modalRef.close();
          if (this.flightInfo.isAuthorization) {
            this.flightLleegoService.requestAuthorization(
              this.flightInfo.flightRequest,
              this.flightInfo.externalUser,
              this.flightInfo.canUseTRM,
              this.flightInfo.navigationExtras,
              {
                skipRedirect: true,
                onSuccess: () => {
                  continueWithHotel(true);
                },
                onFail: (err) => {
                  continueWithHotel(false, err);
                }
              }
            );
          } else {
            this.flightLleegoService.doFlightBooking(
              this.flightInfo.flightRequest,
              this.flightInfo.projectData,
              this.flightInfo.bookingQuery,
              this.flightInfo.fareSelected,
              this.flightInfo.expectedAmountSeats,
              this.flightInfo.totalBaggagePrice,
              this.flightInfo.priorityPrice,
              this.flightInfo.priceChanged,
              this.flightInfo.navigationExtras,
              this.flightInfo.externalUser,
              this.flightInfo.canUseTRM,
              this.flightInfo.user,
              this.flightInfo.selectedFlights,
              this.flightInfo.travelersAge,
              this.flightInfo.flightSelectedStateBackup,
              this.flightInfo.farePricing,
              this.flightInfo.totalPrice,
              this.flightInfo.canUseResident,
              this.flightInfo.selectedBaggages,
              this.flightInfo.selectedPriority,
              this.flightInfo.extraInfoForm,
              this.flightInfo.fareName,
              this.flightInfo.residentOptions,
              this.flightInfo.userUuid,
              this.isPackageRate,
              {
                onSuccess: (_res) => {
                  continueWithHotel(true);
                },
                onAvailOut: () => {
                  backToFlightResults();
                },
                onFail: (reason, err) => {
                  if (reason === 'AVAIL_OUT') {
                    backToFlightResults();
                    return;
                  }

                  continueWithHotel(false, err);
                },
                onLetItGo: (err) => {
                  continueWithHotel(false, err);
                }
              }
            );
          }

          return;
        }

        this.continueHotelBookingFlow(bookingInfo, modalRef, selectedCard);
      }

      });
    });
  }

  getAuthorization(rooms: any[]) {
    if (
      rooms.some((r) => r.userBookingOption === 2) ||
      this.userFilter.onlyAuthorization
    ) {
      return true;
    }
  }

  showPaymentCardSelector(): Promise<any> {
    if (this.company.bookedWithoutCard) {
      return Promise.resolve(null);
    }

    if (!Array.isArray(this.user.paymentCards)) {
      this.user.paymentCards = this.user.paymentCards ? [this.user.paymentCards] : [];
    }

    /* if (!Array.isArray(this.user.personalPaymentCards)) {
      this.user.personalPaymentCards = this.user.personalPaymentCards ? [this.user.personalPaymentCards] : [];
    } */
   this.user.paymentCards = this.user.paymentCards.filter(c => c?.token);
   const defaultToken = this.company?.cardRedsys?.find(c => c?.isDefault && c?.token)?.token || null;

    if (defaultToken) {
      this.user.paymentCards = [
        ...this.user.paymentCards.filter(c => c.token === defaultToken),
        ...this.user.paymentCards.filter(c => c.token !== defaultToken),
      ];
    }

    const stateData = {
      searchConfig: this.searchService.searchConfig,
      hotelsMapCopy: this.hotelsMapCopy.slice(0, 15),
      filters: this.filters,
      starAuthRequired: this.starAuthRequired,
      facilities: this.facilities,
      selectedUsers: this.selectedUsers,
      projectData: this.projectData,
      company: this.company.uuid,
      selectedPolicy: this.selectedPolicy
    };
    localStorage.setItem('stateRedirect', JSON.stringify(stateData));

    return new Promise((resolve) => {
      const modalRef = this.modalService.open(UserCardModalComponent, {
        windowClass: 'custom-modal-user-card',
        centered: true,
        backdrop: 'static',
        keyboard: false
      });
      modalRef.componentInstance.company = this.company;
      modalRef.componentInstance.bookCards = this.user.paymentCards;
      /* modalRef.componentInstance.bookPersonalCards = this.user.personalPaymentCards; */
      modalRef.componentInstance.fromBookSelect = true;
      modalRef.componentInstance.bookType = 'hotel';
      modalRef.componentInstance.user = this.user;
      modalRef.componentInstance.cardSelected.subscribe((selectedCard) => {
        resolve(selectedCard);
      });
      modalRef.result.catch(() => {
        resolve(null);
      });
    });
  }

  getUserBookingOption(rate: any): number {
    const { priceMin, priceMax, pricesByLocation } = this.userFilter;
    const checkIn = new Date(
      moment(this.ngbDateParser.format(this.searchConfig.checkIn), "DD/MM/YYYY").toString()
    );
    const checkOut = new Date(
      moment(this.ngbDateParser.format(this.searchConfig.checkOut), "DD/MM/YYYY").toString()
    );
    const totalNights = Math.floor(Math.abs(checkOut.getTime() - checkIn.getTime()) / (1000 * 60 * 60 * 24));
    const generalMax = priceMax * totalNights;
    const ratePrice = Number(rate.totalWithPercentage);

    let applicableMax = generalMax;

    if (this.formattedPlace && pricesByLocation?.length) {
      const match = pricesByLocation.find(loc =>
        this.formattedPlace.includes(loc.placeName.toLowerCase())
      );
      if (match) {
        applicableMax = Number(match.priceMax) * totalNights;
      }
    }

    return (ratePrice > priceMin &&
            ratePrice < applicableMax &&
            !this.canOnlyRequestRooms)
      ? 1
      : 2;
  }

  cleanSearchData() {
    this.searchService.searchConfig = {
      checkIn: null,
      checkOut: null,
      latitude: "",
      locationText: "",
      longitude: "",
      minElements: "0",
      uuid: "",
      occupancies: [
        {
          rooms: 1,
          adults: 1,
          children: 0,
          paxes: [],
        },
      ],
    };
    this.searchService.hotelsList = [];
    this.searchService.hotelsMap = [];
  }

  scrollToComponent() {
    this.scrollAfterChangeRoom.nativeElement.scrollIntoView({
      behavior: "smooth",
    });
  }

  scrollToBottom() {
    if (this.bottom) {
      this.bottom.nativeElement.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  }

  addTravellersNames() {
    const modalRef = this.modalService.open(AccommodationGuestsComponent, {
      size: "lg",
      centered: true,
      backdrop : 'static',
      keyboard : false
    });
    const guestsAux = this.selectedUsers.map(user => ({
      name: user.name,
      surname: user.lastname
    }));

    modalRef.componentInstance.guests = guestsAux;
    modalRef.componentInstance.sendInfo.subscribe((result: any[]) => {
      if (!result.some((g) => !g.name || g.name === '' || !g.surname || g.surname === '')) {
        this.guests = result;
        modalRef.close();
      }
    });
  }

  createBooking(params, modalRef, roomBooked, roomBookedIdx, bookingInfo) {
    const correlation = crypto.randomUUID();
    const targetUuid = Array.isArray(params.userUuid) ? params.userUuid[0] : params.userUuid;
    const userIndex = this.selectedUsers?.findIndex(u => u.uuid === targetUuid) ?? -1;
    if (userIndex !== -1) {
      this.selectedUsers[userIndex].correlationId = correlation;
    }

    const { latitude, longitude } = params.hotel.coordinates;
    this.googleMaps.geocodeLatLng(Number(latitude), Number(longitude)).subscribe(
      (result) => {
        if (result && result.city) {
          params.hotel.destinationName = result.city;
          this.hotel.destinationName = result.city;
        }
        this.finalizeBooking(params, modalRef, roomBooked, roomBookedIdx, bookingInfo, correlation);
      },
      (error) => {
        this.finalizeBooking(params, modalRef, roomBooked, roomBookedIdx, bookingInfo, correlation);
      }
    );
  }
  
  finalizeBooking(params, modalRef, roomBooked, roomBookedIdx, bookingInfo, correlation) {
    this.pendingHotel.add(correlation);
    this.updatePackageLoading();
    modalRef.close();
    this.utilsService.correlationId.push(correlation);
    params['correlationId'] = correlation;
    bookingInfo.rooms[roomBookedIdx].correlationId = correlation;
    this.bookingInfo = bookingInfo;

    this.utilsService.setSelectedUsers(this.selectedUsers);
    this.utilsService.setBookingInfo(bookingInfo);
    this.utilsService.setHotelInfo(this.hotel);
    this.utilsService.setSelectedRooms(this.selectedRooms);
    this.utilsService.setProjectData(this.projectData);
    this.bookedService.createBooked(params).subscribe(
      (created: Booked) => {
      },
      (err) => {
        this.pendingHotel.delete(correlation);
        const idx = this.utilsService.correlationId.indexOf(correlation);
        if (idx !== -1) this.utilsService.correlationId.splice(idx, 1);

        if (this.packageFlow.enabled) {
          this.packageFlow.hotelDone = (this.pendingHotel.size === 0);
          this.updatePackageLoading();
          this.tryFinishPackageFlow();
        } else {
          this.utilsService.loadingHotels = false;
        }
        this.createBookingFailed(err, roomBooked, roomBookedIdx, params, bookingInfo);
      }
    );
  }

  createAuthorization(bookingInfo, params, modalRef) {
    const { latitude, longitude } = params.hotel.coordinates;
    this.googleMaps.geocodeLatLng(Number(latitude), Number(longitude)).subscribe(
      (result) => {
        if (result && result.city) {
          params.hotel.destinationName = result.city;
        }
        this.proceedWithAuthorization(bookingInfo, params, modalRef);
      },
      (error) => {
        this.proceedWithAuthorization(bookingInfo, params, modalRef);
      }
    );
  }
  
  proceedWithAuthorization(bookingInfo, params, modalRef) {
    let requestParams = {
      type: "booking",
      bookingData: params,
    };
    if (!this.isUser) {
      requestParams["userUuid"] = this.uuidUser;
    }
    requestParams["price"] =
      requestParams["bookingData"].rooms[0].net;
    if (bookingInfo.customCode !== "") {
      requestParams["customCode"] = bookingInfo.customCode;
    }
    if (bookingInfo.costCenter !== "") {
      requestParams["costCenter"] = bookingInfo.costCenter;
    }
    if (bookingInfo.travellerReason !== "") {
      requestParams["travellerReason"] = bookingInfo.travellerReason;
    }
    const correlation = crypto.randomUUID();
    this.utilsService.correlationId.push(correlation);
    requestParams.bookingData['correlationId'] = correlation;
    if (this.projectData && this.projectData.selectedProject && this.projectData.selectedProject.uuid) {
      requestParams['selectedProjectId'] = this.projectData.selectedProject.uuid;
    }
    
    this.bookedService.requestAuthorization(requestParams).subscribe(
      () => {
        modalRef.close();
        this.utilsService.loadingHotels = false;
        this.translate
          .get([
            "common.congrat",
            "search.search-booked.success-room-request",
          ])
          .subscribe((response) => {
            Swal.fire({
              position: "center",
              imageUrl: "../../../../../assets/img/svg/check-circle.svg",
              title: response["common.congrat"],
              text: response["search.search-booked.success-room-request"],
              showConfirmButton: false,
              timer: 3000,
            }).then(() => {
              const route = this.utilsService.getNavigationRoute(this.externalUser, null, this.canUseTRM);
              if (route) {
                if (this.packageFlow.enabled) {
                  this.packageFlow.hotelDone = true;
                  this.updatePackageLoading();
                  this.tryFinishPackageFlow();
                  return;
                }
                this.router.navigate([route]);
              }
            });
          });
        this.authService.totalAuthorizations++;
      },
      (err) => {
        if (err.status === 403 && err.error?.message === "This action is not allowed in this plan") {
          this.translate.get("authorization.not-allowed-plan").subscribe((translatedMessage) => {
            this.ngxToastrService.typeInfo('', translatedMessage);
          });
          modalRef.close();
          Swal.close();
          this.utilsService.loadingHotels = false;
          const route = this.utilsService.getNavigationRoute(this.externalUser, null, this.canUseTRM);
          if (route) {
            this.router.navigate([route]);
          }
          return;
        } 
        modalRef.close();
        Swal.close();
        this.utilsService.loadingHotels = false;
        const author = [this.externalUser?.name, this.externalUser?.lastname]
          .filter(Boolean)
          .join(" ")
          .trim();
        const body = {
          hotel: {
            name: this.hotel.name,
            totalRooms: this.searchConfig.occupancies.length,
            room: {
              adults: this.totalAdults,
              price:
                params.rooms[0].rates[0].totalWithPercentage ||
                `${params.rooms[0].rates[0].net}`,
              roomNumber: this.getCurrentOccupancyIndex(),
              roomName: params.rooms[0].name,
            },
            address: this.hotel.address,
          },
          totalPrice: this.totalPrice.toLocaleString("es-ES", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          }),
          cancellationPolicies: params.rooms[0].rates[0].cancellationPolicies[0]?.from,
          checkIn: moment(new Date(params.checkIn)).format("DD/MM/YYYY"),
          checkOut: moment(new Date(params.checkOut)).format("DD/MM/YYYY"),
          author: author || "No consta",
        };
        this.travelUtilsService.removeTravelLocalStorage();
        if (bookingInfo.customCode !== "") {
          body["customCode"] = bookingInfo.customCode;
        }
        if (bookingInfo.costCenter !== "") {
          body["costCenter"] = bookingInfo.costCenter;
        }
  
        if (bookingInfo.adminHotelComment !== "") {
          body["comments"] = bookingInfo.adminHotelComment;
        }
  
        if (this.selectedRooms[this.getCurrentOccupancyIndex()].rates[0].boardCode === "BB") {
          body["breakfast"] = true;
        } else {
          body["breakfast"] = false;
        }
  
        if (this.selectedRooms[this.getCurrentOccupancyIndex()]?.rates[0]?.boardName) {
          body["boardName"] =
            this.selectedRooms[this.getCurrentOccupancyIndex()].rates[0].boardName;
        }
  
        if (this.selectedRooms[this.getCurrentOccupancyIndex()].rates[0].cancellationPolicies) {
          body["cancellation"] = true;
          body["cancellationDate"] =
            this.selectedRooms[this.getCurrentOccupancyIndex()].rates[0].cancellationPolicies[0]?.from;
        } else {
          body["cancellation"] = false;
        }
        if(this.projectData && this.projectData.selectedProject && this.projectData.selectedProject.uuid !== "none"){
          body["project"] = this.projectData.selectedProject.title || "";
        }

        this.utilsService.sendEmailOperations(
          LetItGoType.hotel,
          body,
          this.uuidUser
        );
        const route = this.utilsService.getNavigationRoute(this.externalUser, null, this.canUseTRM);
        if (route) {
          if (this.packageFlow.enabled) {
            this.packageFlow.hotelDone = true;
            this.updatePackageLoading();
            this.tryFinishPackageFlow();
            return;
          }
          this.router.navigate([route]);
        }
      }
    );
  }

  createBookingFailed(err, roomBooked, roomBookedIdx, params, bookingInfo) {
    if (!this.packageFlow.enabled) {
      this.cleanSearchData();
      this.travelUtilsService.removeTravelLocalStorage();
    }

    Swal.close();

    if (!this.packageFlow.enabled) {
      this.utilsService.loadingHotels = false;
    } else {
      this.updatePackageLoading();
    }

    // Se comprueba si es letitgo o si es fallo de tarjeta
    if (
      err.status === 422 &&
      err.error &&
      err.error.message ===
        "No tienes permisos para realizar la reserva sin tarjeta de crédito"
    ) {
      this.translate
        .get(["common.card-permission-error"])
        .pipe(take(1))
        .subscribe((value) =>
          this.ngxToastrService.typeInfo(
            null,
            value["common.card-permission-error"]
          )
        );
    } else if (err && err.status === 422) {
      this.translate
        .get(["agency.search.search-booked.error-room-booked"])
        .pipe(take(1))
        .subscribe((value) =>
          this.ngxToastrService.typeInfo(
            null,
            value["agency.search.search-booked.error-room-booked"]
          )
        );
    } else {
      // Se elimina el mensaje de error para poner el swal con el envío del email a operaciones
      /*                   this.translate
                      .get("search.search-booked.error-room-booked")
                      .subscribe((resp) => {
                        this.ngxToastrService.typeInfo(resp, err.error.message);
                      }); */
      const author = [this.externalUser?.name, this.externalUser?.lastname]
        .filter(Boolean)
        .join(" ")
        .trim();
      const body = {
        hotel: {
          name: this.hotel.name,
          totalRooms: this.searchConfig.occupancies.length,
          room: {
            adults: this.totalAdults,
            price:
              roomBooked.rates[0].totalWithPercentage ||
              `${roomBooked.rates[0].net}`,
            roomNumber: roomBookedIdx,
            roomName: roomBooked.name,
          },
          address: this.hotel.address,
        },
        guests: params.guests,
        totalPrice: this.totalPrice.toLocaleString("es-ES", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }),
        cancellationPolicies: roomBooked.rates[0].cancellationPolicies[0]?.from,
        checkIn: moment(new Date(params.checkIn)).format(
          "DD/MM/YYYY"
        ),
        checkOut: moment(new Date(params.checkOut)).format(
          "DD/MM/YYYY"
        ),
        author: author || "No consta",
      };
      this.travelUtilsService.removeTravelLocalStorage();
      if (bookingInfo.customCode !== "") {
        body["customCode"] = bookingInfo.customCode;
      }
      if (bookingInfo.costCenter !== "") {
        body["costCenter"] = bookingInfo.costCenter;
      }

      if (bookingInfo.adminHotelComment !== "") {
        body["comments"] = bookingInfo.adminHotelComment;
      }

      if (
        this.selectedRooms[roomBookedIdx].rates[0].boardCode ==
        "BB"
      ) {
        body["breakfast"] = true;
      } else {
        body["breakfast"] = false;
      }

      if (
        this.selectedRooms[roomBookedIdx]?.rates[0]?.boardName
      ) {
        body["boardName"] =
          this.selectedRooms[roomBookedIdx].rates[0].boardName;
      }

      if (
        this.selectedRooms[roomBookedIdx].rates[0]
          .cancellationPolicies
      ) {
        body["cancellation"] = true;
        body["cancellationDate"] =
          this.selectedRooms[
            roomBookedIdx
          ].rates[0].cancellationPolicies[0]?.from;
      } else {
        body["cancellation"] = false;
      }
      if(this.projectData && this.projectData.selectedProject && this.projectData.selectedProject.uuid !== "none"){
        body["project"] = this.projectData.selectedProject.title || "";
      }

      this.utilsService.sendEmailOperations(
        LetItGoType.hotel,
        body,
        params.userUuid ? (Array.isArray(params.userUuid) ? params.userUuid[0] : params.userUuid) : null
      );
      this.translate
        .get(["common.congrat", "common.operations"])
        .subscribe((resultOperations) => {
          Swal.fire({
            position: "center",
            imageUrl:
              "../../../../../assets/img/svg/check-circle.svg",
            title: resultOperations["common.congrat"],
            text: resultOperations["common.operations"],
            showConfirmButton: false,
            timer: this.utilsService.letItGoTimer,
            timerProgressBar: true,
          }).then(() => {
            if (this.packageFlow.enabled) {
              this.packageFlow.hotelDone = (this.pendingHotel.size === 0);
              this.updatePackageLoading();
              this.tryFinishPackageFlow();
              return;
            }
            const route = this.utilsService.getNavigationRoute(this.externalUser, null, this.canUseTRM);
            if (route) {
              this.router.navigate([route], { queryParams: { specialAction: true } });
            }
          });
        });
      }
  }

  onPanelOpened() {
    this.isDescriptionExpanded = true;
  }

  onPanelClosed() {
    this.isDescriptionExpanded = false;
  }

  onDetailsOpened() {
    this.isDetailsExpanded = true;
  }

  onDetailsClosed() {
    this.isDetailsExpanded = false;
  }

  getDescriptionPanelClass() {
    return {
      'expanded-margin': this.isDescriptionExpanded
    };
  }

  getDetailsPanelClass() {
    return {
      'expanded-margin': this.isDetailsExpanded
    };
  }

  isFilterChecked(filterCode: string): boolean {
    return this.selectedFilters.has(filterCode);
  }

  applyFilters(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.selectedFilters.add(checkbox.id);
    } else {
      this.selectedFilters.delete(checkbox.id);
    }
    this.filteredRooms = this.filterByOccupancy(this.hotel.rooms);
    this.updateFilteredRates();
  }

  updateFilteredRates() {
    this.filteredRates = {};
    this.filteredRooms.forEach(room => {
    this.filteredRates[room.code] = this.filterDuplicateRates(room.rates, this.selectedBedTypes[room.code]);
    });
  }

  hasFreeCancellation(rate) {
    return rate.cancellationPolicies && rate.cancellationPolicies[0] && this.isSameOrAfterToday(rate.cancellationPolicies[0]?.from);
  }

  formatCancellationDate(date: string): string {
    return moment(date).format('DD/MM/YYYY');
  }

  filterDuplicateRates(rates: any[], selectedBedType: string) {
    const uniqueRates = [];
    const seen = new Set();
  
    for (const rate of rates) {
      const rateIdentifier = `${rate.totalWithPercentage}-${rate.cancellationPolicies[0]?.from}-${rate.cancellationPolicies[0]?.amountWithPercentage}-${rate.rateType}-${rate.adults}`;
  
      if (!seen.has(rateIdentifier)) {
        seen.add(rateIdentifier);
        uniqueRates.push(rate);
      } else {
        const existingRate = uniqueRates.find(r => {
          const identifier = `${r.totalWithPercentage}-${r.cancellationPolicies[0]?.from}-${r.cancellationPolicies[0]?.amountWithPercentage}-${r.rateType}-${r.adults}`;
          return identifier === rateIdentifier;
        });
  
        if (existingRate && rate.bed === selectedBedType && existingRate.bed !== selectedBedType) {
          const index = uniqueRates.indexOf(existingRate);
          uniqueRates[index] = rate;
        }
      }
    }
    return uniqueRates;
  }

  getFilteredRates(roomCode: string) {
    return this.filteredRates[roomCode]?.filter(rate => rate.adults === this.selectedOccupancy.adults) || [];
  }

  getUniqueBedTypes(rates: any[]): string[] {
    const bedTypes = rates.map(rate => rate.bed);
    return Array.from(new Set(bedTypes));
  }

  onBedTypeChange(roomCode: string, event: any) {
    this.selectedBedTypes[roomCode] = event.value;
    this.filterRatesByBedType(roomCode);
  }
  
  filterRatesByBedType(roomCode: string) {
    const rooms = this.hotel.rooms.filter(r => r.code === roomCode);

    if (rooms.length) {
      let filteredByBed = [];
  
      rooms.forEach(room => {
        const rates = room.rates.filter(rate => rate.bed === this.selectedBedTypes[roomCode]);
        filteredByBed = [...filteredByBed, ...rates];
      });
      this.filteredRates[roomCode] = this.filterDuplicateRates(filteredByBed, this.selectedBedTypes[roomCode]);
    }
  }

  initializeFilteredRates() {
    const uniqueRoomCodes = new Set(this.hotel.rooms.map(room => room.code));
    uniqueRoomCodes.forEach(roomCode => {
      const rooms = this.hotel.rooms.filter(r => r.code === roomCode);
      const allRates = rooms.reduce((acc, room) => acc.concat(room.rates), []);
      const bedTypes = this.getUniqueBedTypes(allRates);
      this.selectedBedTypes[roomCode] = bedTypes.length ? bedTypes[0] : '';
      this.filterRatesByBedType(roomCode);
    });
  }
  
  toggleRoomRatesVisibility(roomCode: string) {
    this.roomRatesVisibility[roomCode] = !this.roomRatesVisibility[roomCode];
  }

  getMinPrice(rates: any[]): number {
    return Math.min(...rates.map(rate => rate.totalWithPercentage));
  }

  addToTravel(itemUuid: any){
    if (this.utilsService.hasProcessedUuid(itemUuid)) {
      return;
    }
    this.utilsService.addProcessedUuid(itemUuid);

    const checkInAux = moment(
      this.ngbDateParser.format(this.searchConfig.checkIn),
      "DD/MM/YYYY"
    ).format("YYYY-MM-DD");
    const checkOutAux = moment(
      this.ngbDateParser.format(this.searchConfig.checkOut),
      "DD/MM/YYYY"
    ).format("YYYY-MM-DD");

    const addBody = {
      item: {
        type: "booking",
        uuid: itemUuid,
        initDate: checkInAux,
        endDate: checkOutAux
      },
    };
    this.travelUtilsService.addItemToTravel(addBody, this.projectData.selectedProject.uuid);
  }

  hasFilter(code: string): boolean {
    if (!this.userFilter) return false;
    if (code.toUpperCase() === 'BREAKFAST') {
      return !!this.userFilter.breakfast;
    }
    return false;
  }

  isPackage() {
    return this.hotel.rooms.some((room) => room.rates.some((rate) => rate.saleScenario?.package === true))
  }

  getTotalPackage() {
    return (this.totalPrice + this.flightInfo.totalPrice).toFixed(2)
  }

  private tryFinishPackageFlow() {
    if (!this.packageFlow.enabled || this.packageFlow.navigated) return;

    if (this.packageFlow.hotelDone && this.packageFlow.flightDone) {
      this.packageFlow.navigated = true;

      this.updatePackageLoading();

      this.cleanSearchData();

      const route = this.utilsService.getNavigationRoute(this.externalUser, null, this.canUseTRM);
      if (route) {
        this.router.navigate([route], { queryParams: { specialAction: true } });
      }
    }
  }

  private resolvePackageFlight(doneOk: boolean, err?: any) {
    if (!this.packageFlow.enabled) return;

    this.packageFlow.flightDone = true;
    this.packageFlow.flightFailed = !doneOk;
    this.packageFlow.flightErr = err ?? null;
    this.updatePackageLoading();
  }

  private updatePackageLoading() {
    if (!this.packageFlow.enabled) return;
    const pending = !(this.packageFlow.hotelDone && this.packageFlow.flightDone);
    this.utilsService.loadingHotels = pending;
  }

  private startPackageFlowIfNeeded() {
    this.packageFlow.enabled = (this.isPackageRate === 'flight' && this.isPackage());

    if (!this.packageFlow.enabled) return;

    this.packageFlow.hotelDone = false;
    this.packageFlow.flightDone = false;
    this.packageFlow.navigated = false;
    this.packageFlow.flightFailed = false;
    this.packageFlow.flightErr = null;
  }

  private continueHotelBookingFlow(bookingInfo: any, modalRef: any, selectedCard: any) {
    const checkInAux = moment(
      moment(
        this.ngbDateParser.format(this.searchConfig.checkIn),
        "DD/MM/YYYY"
      ).toLocaleString()
    ).format("YYYY-MM-DD");

    const checkOutAux = moment(
      moment(
        this.ngbDateParser.format(this.searchConfig.checkOut),
        "DD/MM/YYYY"
      ).toLocaleString()
    ).format("YYYY-MM-DD");

    bookingInfo.rooms.forEach((room, index) => {
      const params = {
        rooms: [room],
        destinationName: this.hotel.address,
        checkIn: checkInAux,
        checkOut: checkOutAux,
        userUuid: this.selectedTravelers[index] ?? [this.uuidUser],
        comments: bookingInfo.adminHotelComment ?? "",
        hotelName: this.hotel.name,
        guests: this.guests.splice(0, room.paxes.length),
      };

      if (!this.company.bookedWithoutCard && selectedCard) {
        params["paymentCard"] = {
          name: selectedCard.name,
          token: selectedCard.token,
        };
      }

      if (bookingInfo.customCode !== "") {
        params["customCode"] = bookingInfo.customCode;
      }

      if (bookingInfo.costCenter !== "") {
        params["costCenter"] = bookingInfo.costCenter;
      }

      params["hotel"] = this.hotel;
      params["hotel"].rooms = [room];

      if (this.isEmployee || this.isAdmin) {
        this.canRequest = true;
      }

      if (
        (this.getUserBookingOption(room.rates[0]) === 1 &&
          this.canRequest &&
          !this.starAuthRequired &&
          !this.canOnlyRequestRooms) ||
        this.isEmployee ||
        this.isAdmin
      ) {
        const bookingInfoForBooking = { ...bookingInfo };
        delete bookingInfoForBooking.travellerReason;
        this.createBooking(
          params,
          modalRef,
          room,
          bookingInfo.rooms.indexOf(room),
          bookingInfoForBooking
        );
      } else {
        this.createAuthorization(bookingInfo, params, modalRef);
      }
    });
  }

}
